function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import ExpertHeader from "../Tableheaders/ExpertHeader";
import Calendar from '@toast-ui/react-calendar';

const ExpertCalendar = ({
  handleTimezones,
  expertAttr,
  dayTheme
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "calendarExpert"
  }, /*#__PURE__*/React.createElement(ExpertHeader, {
    id: "EXPERT",
    handleTimezones: handleTimezones
  }), /*#__PURE__*/React.createElement(Calendar, _extends({}, expertAttr, {
    theme: dayTheme
  })));
};

export default ExpertCalendar;